import styled from 'styled-components';

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 0;

  .text-858dbd {
    color: var(--color-text-muted);
  }
`;
